import { TranslationType } from '../types';

export const ru: TranslationType = {
  common: {
    wallets: 'Кошельки',
    dashboard: 'Панель управления',
    settings: 'Настройки',
    darkMode: 'Тёмная тема',
    lightMode: 'Светлая тема',
    language: 'Язык',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: 'Блог'
  },
  footer: {
    quickLinks: 'Быстрые ссылки',
    about: 'О нас',
    terms: 'Условия использования',
    privacy: 'Политика конфиденциальности',
    contact: 'Связаться с нами',
    copyright: '© 2025 XCH.live. Все права защищены.',
    description: 'Продвинутая платформа мониторинга для кошельков блокчейна Chia. Получайте уведомления о транзакциях в реальном времени, защищайте свои активы с помощью мгновенных уведомлений и контролируйте активность холодного кошелька.',
    connectWithUs: 'Свяжитесь с нами',
    builtBy: 'Создано с ❤️ командой Spacescan.io'
  },
  home: {
    hero: {
      title: 'Мониторинг вашего холодного кошелька Chia',
      subtitle: 'Получайте мгновенные email-уведомления о транзакциях XCH',
      input: {
        label: 'Введите мастер-ключ (96 символов) или адрес XCH',
        placeholder: 'Введите мастер-ключ (96 символов) или адрес XCH',
        helper: 'Введите ваш мастер-ключ или адрес XCH, чтобы начать мониторинг'
      },
      buttons: {
        cardprefix: '$12',
        card: 'Оплатить картой',
        strprefix: '50% OFF',
        str: 'Оплатить STR'
      }
    },
    features: {
      title: 'Защитите свою Chia, пока не поздно',
      subtitle: 'Не ждите хакеров — активно защищайте свой холодный кошелек с помощью круглосуточного мониторинга',
      vault: {
        title: 'Включить Vault и Clawback',
        description: 'Защитите свои активы с помощью расширенных функций хранилища и защиты возврата'
      },
      monitoring: {
        title: 'Безопасный мониторинг',
        description: 'Отслеживайте активность холодного кошелька без раскрытия приватных ключей'
      },
      alerts: {
        title: 'Мгновенные уведомления',
        description: 'Получайте мгновенные email-уведомления о любых транзакциях'
      },
      recovery: {
        title: 'Возврат средств',
        description: 'Возвращайте средства из несанкционированных транзакций в период возврата'
      }
    },
    metrics: {
      title: 'Наше влияние в цифрах',
      walletsMonitored: {
        label: 'Отслеживаемых кошельков'
      },
      alertsSent: {
        label: 'Отправлено уведомлений'
      },
      transactionsAnalyzed: {
        label: 'Проанализировано транзакций'
      }
    },
    testimonials: {
      title: 'Что говорят наши пользователи',
      items: [
        {
          quote: 'XCH.live даёт мне спокойствие, зная, что мой холодный кошелёк круглосуточно отслеживается. Мгновенные уведомления — это настоящий прорыв.',
          author: 'Михаил Чен',
          role: 'Фермер Chia'
        },
        {
          quote: 'Настройка была невероятно простой, а мониторинг надёжным. Именно то, что мне нужно было для моих активов Chia.',
          author: 'Сара Джонсон',
          role: 'Крипто-инвестор'
        },
        {
          quote: 'Лучшее решение для мониторинга кошельков Chia. Email-уведомления быстрые, а панель управления очень интуитивная.',
          author: 'Давид Ким',
          role: 'Блокчейн-разработчик'
        }
      ]
    }
  },
  settings: {
    title: 'Настройки',
    subtitle: 'Управление настройками кошелька',
    notifications: {
      title: 'Уведомления',
      emailNotifications: 'Email-уведомления',
      emailDescription: 'Получать обновления о транзакциях по email',
      threshold: {
        title: 'Порог транзакций',
        description: 'Минимальная сумма XCH для отправки уведомлений (минимум 1 XCH)'
      }
    },
    walletInfo: {
      title: 'Информация о кошельке',
      masterKey: 'Мастер-ключ'
    },
    actions: {
      save: 'Сохранить изменения',
      delete: 'Удалить кошелёк'
    },
    messages: {
      success: 'Настройки успешно сохранены!',
      error: {
        generic: 'Не удалось обновить настройки',
        threshold: 'Порог должен быть не менее 1 XCH',
        delete: 'Не удалось удалить кошелёк'
      },
      deleteConfirm: 'Вы уверены, что хотите удалить этот кошелёк? Это действие нельзя отменить.'
    }
  },
  wallets: {
    title: 'Ваши кошельки',
    subtitle: 'Управление и мониторинг ваших холодных кошельков',
    status: {
      active: 'Мониторинг активен',
      pending: 'Ожидание оплаты',
      expired: 'Мониторинг истёк',
      timeLeft: {
        days: 'Осталось {{days}}д {{hours}}ч',
        hours: 'Осталось {{hours}}ч {{minutes}}м',
        minutes: 'Осталось {{minutes}}м',
        lessThanMinute: 'Осталось менее 1м'
      }
    },
    actions: {
      payWithCard: 'Оплатить картой',
      completeCryptoPayment: 'Завершить крипто-платёж',
      renewMonitoring: 'Продлить мониторинг',
      dashboard: 'Панель управления',
      settings: 'Настройки',
      addFirstWallet: 'Добавить первый кошелёк',
      removeWallet: 'Удалить кошелёк'
    },
    messages: {
      noWallets: 'Кошельки не найдены'
    }
  },
  dashboard: {
    title: 'Панель управления кошельком',
    tabs: {
      events: 'События',
      addresses: 'Адреса'
    },
    addresses: {
      totalAddresses: 'Всего адресов: {{count}}',
      index: 'Индекс',
      address: 'Адрес',
      actions: 'Действия'
    },
    events: {
      loadMore: 'Загрузить ещё',
      noEvents: 'События не найдены',
      sent: 'Отправлено',
      received: 'Получено',
      spent: 'Потрачено',
      pending: 'В ожидании',
      failed: 'Не удалось',
      showDetails: 'Показать детали',
      hideDetails: 'Скрыть детали',
      block: 'Блок',
      viewOnSpacescan: 'Просмотр на Spacescan',
      transactionHash: 'Хэш транзакции',
      nftsReceived: 'Получены NFT',
      nftsSent: 'Отправлены NFT',
      nftTransaction: 'NFT-транзакция',
      viewNFTDetails: 'Просмотр деталей NFT',
      receivedNFTs: 'Полученные NFT',
      sentNFTs: 'Отправленные NFT'
    }
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    security: {
      question: 'Насколько безопасен ваш сервис мониторинга?',
      answer: 'Наш сервис работает по самым высоким стандартам безопасности, используя только ваш публичный мастер-ключ для целей мониторинга. Ваши средства остаются полностью безопасными, так как у нас никогда нет доступа к приватным ключам или возможностям траты. Мы используем криптографические стандарты BLS-12-381, где приватные ключи (32 байта) и публичные ключи (48 байт) остаются раздельными и безопасными.',
      learnMore: 'Узнать больше о BLS-ключах в Chia →'
    },
    monitoring: {
      question: 'Какова частота мониторинга транзакций?',
      answer: 'Наша система отслеживает транзакции в реальном времени, проверяя каждый новый блок в блокчейне Chia. Мы отслеживаем активность по всем вашим контролируемым адресам, обеспечивая мгновенное уведомление о любых транзакциях, затрагивающих ваш кошелёк.'
    },
    masterKey: {
      question: 'Как найти публичный мастер-ключ моего кошелька?',
      answer: 'Доступ к вашему публичному мастер-ключу можно получить через GUI или CLI кошелька Chia. Мы подготовили подробное видео-руководство, которое проведёт вас через этот процесс. Важно: никогда не делитесь вашими приватными ключами или сид-фразой - для нашего сервиса мониторинга нужен только публичный мастер-ключ.',
      videoTitle: 'Как найти ваш публичный мастер-ключ',
      learnMore: 'Прочитать подробное руководство по поиску ключей →'
    },
    addresses: {
      question: 'Сколько адресов отслеживается с моим мастер-ключом?',
      answer: 'Наш сервис отслеживает 100 производных адресов, связанных с вашим мастер-ключом, обеспечивая полное покрытие транзакционной активности вашего кошелька.'
    },
    singleAddress: {
      question: 'Могу ли я отслеживать конкретный адрес вместо использования мастер-ключа?',
      answer: 'Да, наш сервис предлагает гибкость в мониторинге отдельных адресов. Вы можете выбрать отслеживание одного конкретного адреса вместо использования мастер-ключа для мониторинга нескольких адресов.'
    },
    notifications: {
      question: 'Как я могу настроить мои уведомления?',
      answer: 'У вас есть полный контроль над вашими email-уведомлениями через настройки кошелька. Наша панель управления предоставляет опции для настройки предпочтений уведомлений в соответствии с вашими потребностями мониторинга.'
    },
    vault: {
      question: 'Что такое Chia vault и как он работает?',
      answer: 'Chia vault — это продвинутая функция безопасности, которая обеспечивает усиленную защиту ваших цифровых активов. Она реализует дополнительные меры безопасности, такие как требования мульти-подписи или транзакции с временной задержкой. Хранилища отделяют хранение активов от монет и могут требовать несколько подписей (m из n мульти-подписей) для одобрения транзакции.',
      learnMore: 'Узнать больше о Chia Vaults →'
    },
    clawback: {
      question: 'Что такое функция clawback в Chia?',
      answer: 'Clawback — это функция безопасности в Chia, которая позволяет отменять транзакции в течение определённого периода времени. При активации получатели должны дождаться истечения периода возврата, прежде чем они смогут получить доступ к переведённым средствам, что обеспечивает дополнительный уровень безопасности транзакций.'
    },
    vaultSupport: {
      question: 'Поддерживает ли ваш сервис функции vault и clawback?',
      answer: 'Хотя мы отслеживаем транзакции с использованием vault и clawback, мы не управляем этими функциями напрямую. Эти функции должны быть настроены при создании кошелька. Наш сервис фокусируется на мониторинге транзакций и доставке уведомлений для ваших адресов.'
    },
    tokens: {
      question: 'Предоставляете ли вы мониторинг для токенов Chia?',
      answer: 'В настоящее время наш сервис мониторинга фокусируется исключительно на транзакциях XCH. Функциональность мониторинга токенов не поддерживается в нашем текущем предложении услуг.'
    },
    nft: {
      question: 'Доступен ли мониторинг NFT-транзакций?',
      answer: 'В настоящее время наш сервис специализируется на мониторинге транзакций XCH. Мониторинг NFT-транзакций не включён в наши текущие возможности сервиса.'
    },
    subscription: {
      question: 'Какова ваша политика подписки и возврата средств?',
      answer: 'Наш сервис предоставляется на основе подписки. Из-за мгновенного характера наших услуг мониторинга мы не предоставляем возврат средств после активации сервиса. Пожалуйста, убедитесь, что вы понимаете наши условия обслуживания перед подпиской.'
    }
  },
  notFound: {
    title: 'Страница не найдена',
    lostMessage: 'Не позволяйте вашей Chia исчезнуть как эта страница - в пустоте!',
    securityMessage: 'Вернитесь на главную страницу и узнайте, как обеспечить безопасность и мониторинг ваших XCH 24/7.',
    protectButton: 'Защитите вашу Chia'
  }
}; 